var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        width: "860px",
        "before-close": _vm.handleClose,
        "close-on-click-modal": false,
        "custom-class": "ccd-dialog",
        top: "4vh"
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "ccd-header", attrs: { slot: "title" }, slot: "title" },
        [
          _c(
            "div",
            {
              staticClass: "ccd-header__icon",
              class:
                _vm.form.coupon_type === "percent"
                  ? "ccd-icon--purple"
                  : "ccd-icon--teal"
            },
            [_c("i", { staticClass: "el-icon-s-ticket" })]
          ),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "ccd-header__title" }, [
              _vm._v(_vm._s(_vm.isEditMode ? "Edit Coupon" : "New Coupon"))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ccd-header__sub" }, [
              _vm._v(
                _vm._s(
                  _vm.isEditMode
                    ? "Update this discount code"
                    : "Create a discount code for your payment forms"
                )
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ccd-body" },
        [
          _c("div", { staticClass: "ccd-sidebar" }, [
            _c(
              "div",
              {
                staticClass: "ccd-ticket",
                class:
                  _vm.form.coupon_type === "percent"
                    ? "ccd-ticket--purple"
                    : "ccd-ticket--teal"
              },
              [
                _c("div", { staticClass: "ccd-ticket__top" }, [
                  _c("div", { staticClass: "ccd-ticket__eyebrow" }, [
                    _vm._v("DISCOUNT CODE")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ccd-ticket__amount" },
                    [
                      _vm.form.amount > 0
                        ? [
                            _vm.form.coupon_type === "percent"
                              ? [
                                  _c(
                                    "span",
                                    { staticClass: "ccd-ticket__value" },
                                    [_vm._v(_vm._s(_vm.form.amount))]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "ccd-ticket__unit" },
                                    [_vm._v("%")]
                                  )
                                ]
                              : [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "ccd-ticket__unit ccd-ticket__unit--pre"
                                    },
                                    [_vm._v("$")]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "ccd-ticket__value" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          parseFloat(_vm.form.amount).toFixed(2)
                                        )
                                      )
                                    ]
                                  )
                                ]
                          ]
                        : _c("span", { staticClass: "ccd-ticket__empty" }, [
                            _vm._v("—")
                          ])
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "ccd-ticket__off" }, [
                    _vm._v("off your order")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ccd-tear" }, [
                  _c("div", {
                    staticClass: "ccd-tear__notch ccd-tear__notch--l"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "ccd-tear__line" }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "ccd-tear__notch ccd-tear__notch--r"
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ccd-ticket__bottom" }, [
                  _c("div", { staticClass: "ccd-ticket__code" }, [
                    _vm._v(_vm._s(_vm.form.code || "YOURCODE"))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ccd-ticket__expiry" },
                    [
                      _c("i", { staticClass: "el-icon-time" }),
                      _vm._v(" "),
                      _vm.form.expire_date
                        ? [
                            _vm._v(
                              _vm._s(_vm.form.expire_date.substring(0, 10))
                            )
                          ]
                        : [_vm._v("No expiry")]
                    ],
                    2
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "ccd-stats" }, [
              _c("div", { staticClass: "ccd-stat" }, [
                _c("div", { staticClass: "ccd-stat__val" }, [
                  _vm._v(_vm._s(_vm.form.max_use > 0 ? _vm.form.max_use : "∞"))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ccd-stat__key" }, [_vm._v("Uses")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ccd-stat" }, [
                _c("div", { staticClass: "ccd-stat__val" }, [
                  _vm._v(
                    _vm._s(
                      _vm.form.min_amount > 0 ? "$" + _vm.form.min_amount : "—"
                    )
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ccd-stat__key" }, [
                  _vm._v("Min. Order")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ccd-stat" }, [
                _c("div", { staticClass: "ccd-stat__val" }, [
                  _vm._v(_vm._s(_vm.form.settings.form_ids.length || "All"))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ccd-stat__key" }, [_vm._v("Forms")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ccd-indicators" }, [
              _c(
                "div",
                {
                  staticClass: "ccd-indicator",
                  class:
                    _vm.form.status === "active"
                      ? "ccd-indicator--green"
                      : "ccd-indicator--gray"
                },
                [
                  _c("span", { staticClass: "ccd-dot" }),
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.form.status === "active" ? "Active" : "Inactive"
                      ) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _vm.form.stackable === "yes"
                ? _c(
                    "div",
                    { staticClass: "ccd-indicator ccd-indicator--blue" },
                    [
                      _c("i", { staticClass: "el-icon-connection" }),
                      _vm._v("\n          Stackable\n        ")
                    ]
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "couponForm",
              staticClass: "ccd-form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-position": "top"
              }
            },
            [
              _c("div", { staticClass: "ccd-section-label" }, [
                _vm._v("Basic Info")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ccd-row ccd-row--2" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "title" } },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "ccd-label",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v("Title")]
                      ),
                      _vm._v(" "),
                      _c("el-input", {
                        attrs: {
                          placeholder: "e.g. Summer Sale",
                          size: "small"
                        },
                        model: {
                          value: _vm.form.title,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "title", $$v)
                          },
                          expression: "form.title"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "code" } },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "ccd-label",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v("\n            Coupon Code\n            "),
                          _c(
                            "button",
                            {
                              staticClass: "ccd-gen",
                              attrs: { type: "button" },
                              on: { click: _vm.generateCode }
                            },
                            [
                              _c("i", { staticClass: "el-icon-refresh" }),
                              _vm._v(" Generate\n            ")
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("el-input", {
                        attrs: { placeholder: "SAVE20", size: "small" },
                        on: {
                          input: function($event) {
                            _vm.form.code = _vm.form.code.toUpperCase()
                          }
                        },
                        model: {
                          value: _vm.form.code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "code", $$v)
                          },
                          expression: "form.code"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "ccd-section-label" }, [
                _vm._v("Discount")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ccd-row ccd-row--2" },
                [
                  _c("el-form-item", { attrs: { prop: "coupon_type" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "ccd-label",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v("Type")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "ccd-pills" }, [
                      _c(
                        "button",
                        {
                          staticClass: "ccd-pill",
                          class: {
                            "ccd-pill--teal": _vm.form.coupon_type === "fixed"
                          },
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              _vm.form.coupon_type = "fixed"
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "ccd-pill__icon" }, [
                            _vm._v("$")
                          ]),
                          _vm._v(" Fixed")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "ccd-pill",
                          class: {
                            "ccd-pill--purple":
                              _vm.form.coupon_type === "percent"
                          },
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              _vm.form.coupon_type = "percent"
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "ccd-pill__icon" }, [
                            _vm._v("%")
                          ]),
                          _vm._v(" Percent")
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "amount" } },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "ccd-label",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.form.coupon_type === "percent"
                                ? "Percent Off"
                                : "Amount Off"
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-input",
                        {
                          attrs: {
                            type: "number",
                            min: "0",
                            step: "0.01",
                            placeholder: "0",
                            size: "small"
                          },
                          model: {
                            value: _vm.form.amount,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "amount", _vm._n($$v))
                            },
                            expression: "form.amount"
                          }
                        },
                        [
                          _c("template", { slot: "append" }, [
                            _vm._v(
                              _vm._s(
                                _vm.form.coupon_type === "percent" ? "%" : "$"
                              )
                            )
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "ccd-section-label" }, [
                _vm._v("Restrictions")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ccd-row ccd-row--2" },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "ccd-label",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v("Start Date")]
                      ),
                      _vm._v(" "),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "No start date",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          size: "small"
                        },
                        model: {
                          value: _vm.form.start_date,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "start_date", $$v)
                          },
                          expression: "form.start_date"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "ccd-label",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v("Expiry Date")]
                      ),
                      _vm._v(" "),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "Never expires",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          size: "small"
                        },
                        model: {
                          value: _vm.form.expire_date,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "expire_date", $$v)
                          },
                          expression: "form.expire_date"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ccd-row ccd-row--3" },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "ccd-label",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v("Min. Order")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-input",
                        {
                          attrs: {
                            type: "number",
                            min: "0",
                            placeholder: "0",
                            size: "small"
                          },
                          model: {
                            value: _vm.form.min_amount,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "min_amount", _vm._n($$v))
                            },
                            expression: "form.min_amount"
                          }
                        },
                        [_c("template", { slot: "prepend" }, [_vm._v("$")])],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "ccd-label",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v("Total Uses")]
                      ),
                      _vm._v(" "),
                      _c("el-input", {
                        attrs: {
                          type: "number",
                          min: "0",
                          placeholder: "Unlimited",
                          size: "small"
                        },
                        model: {
                          value: _vm.form.max_use,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "max_use", _vm._n($$v))
                          },
                          expression: "form.max_use"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "ccd-label",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v("Per User")]
                      ),
                      _vm._v(" "),
                      _c("el-input", {
                        attrs: {
                          type: "number",
                          min: "0",
                          placeholder: "Unlimited",
                          size: "small"
                        },
                        model: {
                          value: _vm.form.per_user_limit,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "per_user_limit", _vm._n($$v))
                          },
                          expression: "form.per_user_limit"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "span",
                    {
                      staticClass: "ccd-label",
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [
                      _vm._v("\n          Applicable Forms\n          "),
                      _c("span", { staticClass: "ccd-hint" }, [
                        _vm._v("· leave empty for all")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        multiple: "",
                        placeholder: "All payment forms",
                        size: "small",
                        loading: _vm.formsLoading
                      },
                      model: {
                        value: _vm.form.settings.form_ids,
                        callback: function($$v) {
                          _vm.$set(_vm.form.settings, "form_ids", $$v)
                        },
                        expression: "form.settings.form_ids"
                      }
                    },
                    _vm._l(_vm.availableForms, function(f) {
                      return _c("el-option", {
                        key: f.id,
                        attrs: { label: f.name, value: f.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "ccd-section-label" }, [
                _vm._v("Options")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ccd-switches" }, [
                _c(
                  "div",
                  { staticClass: "ccd-switch-row" },
                  [
                    _c("div", [
                      _c("div", { staticClass: "ccd-switch-row__label" }, [
                        _vm._v("Stackable")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ccd-switch-row__desc" }, [
                        _vm._v("Allow combining with other coupons")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("el-switch", {
                      attrs: {
                        value: _vm.form.stackable === "yes",
                        "active-color": "#409EFF"
                      },
                      on: {
                        change: function($event) {
                          _vm.form.stackable = $event ? "yes" : "no"
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ccd-switch-row" },
                  [
                    _c("div", [
                      _c("div", { staticClass: "ccd-switch-row__label" }, [
                        _vm._v("Active")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ccd-switch-row__desc" }, [
                        _vm._v("Coupon is usable immediately when enabled")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("el-switch", {
                      attrs: {
                        value: _vm.form.status === "active",
                        "active-color": "#67C23A"
                      },
                      on: {
                        change: function($event) {
                          _vm.form.status = $event ? "active" : "inactive"
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ccd-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleClose } },
            [_vm._v("Cancel")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "primary",
                loading: _vm.saving,
                icon: "el-icon-check"
              },
              on: { click: _vm.saveCoupon }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.isEditMode ? "Update Coupon" : "Create Coupon") +
                  "\n    "
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }